import '@/app/app.css';
import './main.css';

import '@/app/app';

import { SliderProducts } from '@/features/slider-products/slider-products';
import { MainHeader } from '@/features/main/main-header/main-header';
import { MainCollections } from '@/features/main/main-collections/main-collections';
import { MainUspSlider } from '@/features/main/main-usp/main-usp';
import { MainComplexesSlider } from '@/features/main/main-complexes/main-complexes';
import { Collapse } from '@/shared/common/collapse/collapse';
import { SliderNews } from '@/features/slider-news/slider-news';

window.app.MainCollections = MainCollections;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
	document.querySelectorAll('.js-slider-news').forEach((slider) => new SliderNews(slider));
	document.querySelectorAll('.js-collapse').forEach((el) => new Collapse(el).init());
	new MainUspSlider(document.querySelector('.js-main-usp-slider'));
	new MainComplexesSlider(document.querySelector('.js-main-complexes'));
	new MainHeader(document.querySelector('.js-main-banner'));
	new MainCollections(document.querySelector('.js-main-collections'));
});
